import axios from "axios";

// Always talk to the backend on the SAME origin the app is served from.
// The Kubernetes ingress routes every "/api" request on the current host to
// the backend, so this works on any preview/prod host alias without pinning
// to a single REACT_APP_BACKEND_URL value.
const ORIGIN =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;

export const API = `${ORIGIN}/api`;
const TOKEN_KEY = "routa_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
